import React, { useCallback } from 'react'

import cx from '../../../utils/className'

const activatesButton = (key) => key === 'Enter' || key === ' '

/**
 * 在保留 div/span 与现有样式的前提下，补全 role="button"、键盘激活与 aria 名称。
 * 装饰性图标请放在子节点并加 aria-hidden="true"。
 */
const Pressable = React.forwardRef((props, ref) => {
  const {
    children,
    onClick,
    disabled = false,
    className,
    ariaLabel,
    ariaLabelledby,
    role = 'button',
    component: Component = 'div',
    onKeyDown: userOnKeyDown,
    tabIndex: tabIndexProp,
    ...rest
  } = props

  const handleKeyDown = useCallback(
    (e) => {
      if (typeof userOnKeyDown === 'function') {
        userOnKeyDown(e)
      }
      if (e.defaultPrevented) return
      if (disabled || !onClick) return
      if (!activatesButton(e.key)) return
      if (e.key === ' ') {
        e.preventDefault()
      }
      onClick(e)
    },
    [disabled, onClick, userOnKeyDown]
  )

  const tabIndex =
    tabIndexProp !== undefined ? tabIndexProp : disabled ? -1 : 0

  if (process.env.NODE_ENV !== 'production' && !ariaLabel && !ariaLabelledby) {
    // eslint-disable-next-line no-console
    console.warn('[Pressable] Provide ariaLabel or ariaLabelledby for screen readers.')
  }

  return (
    <Component
      ref={ref}
      {...rest}
      role={role}
      tabIndex={tabIndex}
      className={cx(className)}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      aria-disabled={disabled ? true : undefined}
      onClick={disabled ? undefined : onClick}
      onKeyDown={handleKeyDown}
    >
      {children}
    </Component>
  )
})

Pressable.displayName = 'Pressable'

export default Pressable
